import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { server, Auth } from "redux-server-connection";
import urls from "../../reducers/urls";
import { parse } from "querystring";

import Render from "./Render";

class PasswordReset extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  onSubmit(e) {
    e.preventDefault();
    if (e.target[0].value !== e.target[1].value) {
      this.setState({ error: "Las contraseñas ingresadas no coinciden" });
      return;
    }

    this.props
      .sendNewPassword(e.target[0].value, e.target[1].value)
      .then(res => {
        if (!res.ok) {
          this.setState({
            error: res.data ? res.data.message.message : "Ocurrio un error"
          });
          return;
        }

        this.props.history.push("/dashboard");
      });
  }

  render() {
    return (
      <Render
        {...this.props}
        {...this.state}
        onSubmit={this.onSubmit.bind(this)}
      />
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  let url = urls.users["change-password"];
  const params = parse(ownProps.location.search.substring(1));

  if (!Auth.isLoggedIn()) {
    url = urls.users["reset-password"](params.id);
  }

  return {
    sendNewPassword: (password, confirmation) =>
      dispatch(
        server.post(url, "USERS", {
          password,
          confirmation,
          code: params.code
        })
      )
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PasswordReset)
);



// WEBPACK FOOTER //
// ./src/pages/PasswordReset/index.js